import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtCurrency, fmtDate } from "@/lib/format";
import { Panel, SectionLabel, StatusBadge } from "@/components/common/ui-kit";
import { SupplierInvoiceSheet } from "@/components/billing/SupplierInvoiceSheet";

const STATE = { da_abbinare: ["Da abbinare", "amber"], parziale: ["Parziale", "blue"], abbinata: ["Abbinata", "green"] };

export const CompanyPurchasesPanel = ({ companyId }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(null);
  const load = () => api.get("/supplier-invoices", { params: { company_id: companyId } }).then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d?.items.length) return null;
  const year = String(new Date().getFullYear());
  const ytd = d.items.filter((i) => (i.date || "").startsWith(year)).reduce((s, i) => s + i.amount_net, 0);
  return (
    <Panel className="p-5" data-testid="company-purchases-panel">
      <div className="flex items-baseline justify-between gap-2"><SectionLabel>Acquisti · fatture fornitore</SectionLabel>
        <Link to="/fatture-fornitori" className="text-xs font-semibold text-brand-700 hover:underline">Tutte</Link></div>
      <p className="mt-1 text-xs text-slate-500" data-testid="company-purchases-summary">{d.items.length} fatture · {fmtCurrency(d.summary.net)} imponibile totale · {fmtCurrency(ytd)} nel {year}</p>
      <ul className="mt-3 divide-y divide-line">{d.items.slice(0, 8).map((i) => (
        <li key={i.id} className="flex items-center gap-2 py-2 text-sm" data-testid={`company-purchase-${i.id}`}>
          <button type="button" onClick={() => setOpen(i.id)} className="min-w-0 flex-1 truncate text-left font-medium text-ink hover:text-brand-600">Fatt. {i.number || "s.n."} · {fmtDate(i.date)}</button>
          <StatusBadge tone={STATE[i.state][1]}>{STATE[i.state][0]}</StatusBadge>
          <span className="w-24 text-right">{fmtCurrency(i.amount_net)}</span>
        </li>))}</ul>
      <SupplierInvoiceSheet id={open} onClose={() => setOpen(null)} onChanged={load} />
    </Panel>
  );
};
